import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function generateAdvanceCenterOlPayments(ids: number[]) {
  return restApiClient.url(API.centerOlPayments.generateAdvancePayment.url).post({ ids })
}
